import { TableCell, TableRow, Tooltip } from '@material-ui/core';
import { Delete, Email, Phone } from '@material-ui/icons';
import React from 'react';

const LeadsItem = ({ row, index, styles }) => {
	return (
		<TableRow>
			<TableCell>{row.email}</TableCell>
			<TableCell>{row.sentEmail}</TableCell>
			<TableCell>{row.leadsPhoneNumber}</TableCell>
			<TableCell className={styles.contact_group}>
				<Tooltip title='Email'>
					<Email className={styles.email_icon} />
				</Tooltip>
				<Tooltip title='Phone'>
					<Phone className={styles.phone_icon} />
				</Tooltip>
				<Tooltip title='Delete'>
					<Delete className={styles.delete_icon} />
				</Tooltip>
			</TableCell>
		</TableRow>
	);
};

export default LeadsItem;
